'use client'

import { usePathname } from 'next/navigation'

import { getLocaleFromPathname, type Locale } from './config'

export function useLocale(): Locale {
  const pathname = usePathname()

  return getLocaleFromPathname(pathname)
}
